import React, { useState } from 'react';
import Dashboardnavbar from '../../layout/Navbar/Navbar';
import { SiteEmployeeDetails } from './EmployeeTable';

const EmployeeToggleDetails = () => {
    const siteRole = sessionStorage.getItem("role")
    const [toggleState, setToggleState] = useState(1);
    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Employees';
            case 2:
                return 'Actual Attendance';
            case 3:
                return 'BOQ Attendance';
            case 4:
                return 'Office Rent';
            case 5:
                return 'Designation'
            case 6:
                return 'Sub Companies';
            case 7:
                return 'Department';
            case 8:
                return 'Consultant Account Details';
            default:
                return 'Employees';
        }
    };

    return (
        <>
            <Dashboardnavbar name={getSelectedTitle()} url="Employee Management" />
            {/* {siteRole === "SiteManagement" ? <div className='content-tabs'>
                <div className="toggle-button-area" style={{ padding: "34px 30px" }}>
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(1)}
                    >
                        Employees
                    </button>

                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(2)}
                    >
                        Actual Attendance
                    </button>

                    <button
                        className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(3)}
                    >
                        BOQ Attendance
                    </button>
                </div>
            </div>
                :
                <div className='content-tabs'>
                    <div className="toggle-button-area">
                        <button
                            className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                            onClick={() => setToggleState(1)}
                        >
                            Employees
                        </button>
                        {
                            siteRole === "BD" ? "" :
                                <>
                                    <button
                                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                                        onClick={() => setToggleState(2)}
                                    >
                                        Actual Attendance
                                    </button>


                                    <button
                                        className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                                        onClick={() => setToggleState(3)}
                                    >
                                        BOQ Attendance
                                    </button>
                                </>
                        }

                        <button
                            className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                            onClick={() => setToggleState(5)}
                        >
                            Designation
                        </button>
                        <button
                            className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                            onClick={() => setToggleState(6)}
                        >
                            Sub Companies
                        </button>
                        <button
                            className={toggleState === 7 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                            onClick={() => setToggleState(7)}
                        >
                            Department
                        </button>
                        <button
                            className={toggleState === 8 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                            onClick={() => setToggleState(8)}
                        >
                            Consultant Account Details
                        </button>
                    </div>
                </div>
            } */}
            <div className="content-tabs">
                {toggleState === 1 ? <SiteEmployeeDetails /> : null}
            </div>
        </>
    );
};





export default EmployeeToggleDetails;
